<template>
  <v-app :dark="isDark">
    <v-card class="success-screen" :class="{ 'dark-mode': isDark }">
      <div class="success-content">
        <v-icon color="green" size="64">mdi-check-circle</v-icon>
        <h2 class="success-title">Ваша заявка обрабатывается</h2>
      </div>

      <v-footer :dark="isDark" fixed>
        <v-btn block color="primary" class="white--text" height="56px" @click="goToHome">
          Мои заявки
        </v-btn>
      </v-footer>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: 'SuccessScreen',
  data() {
    return {
      theme: 'light'
    };
  },
  computed: {
    isDark() {
      return this.theme === 'dark';
    }
  },
  created() {
    // Get theme from route query param or localStorage
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';
  },
  mounted() {
    if (require('@orta/bridge').isWebViewBridgeAvailable()) {
      require('@orta/bridge').setTitle('Успех');
      require('@orta/bridge').backArrow.setVisible(false);
    }
  },
  methods: {
    goToHome() {
      // Preserve the theme when navigating
      this.$router.push({ name: 'VacationView', replace: true });
    }
  }
}
</script>

<style scoped>
.success-screen {
  flex: 1;
  background-color: var(--bg-color) !important;
  border-radius: 0 !important;
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  height: calc(100vh - 112px);
}

.success-title {
  margin-top: 24px;
  font-size: 24px;
  font-weight: bold;
  color: var(--text-color);
}

.success-message {
  margin-top: 16px;
  font-size: 16px;
  color: #757575;
}
</style>
